import Form from "./Form";

class BasicForm extends Form {
  constructor(form) {
    super(form);
    this.type = "basic";
    console.log(this);
  }

  getData() {
    const data = new FormData();
    const f = this.form;

    data.set("post_id", this.post_id);
    data.set("first_name", f.first_name.value);
    data.set("last_name", f.last_name.value);
    data.set("email", f.email.value);
    data.set("phone", f.phone.value);
    data.set("company", f.company.value);
    data.set("function", f.function.value);

    data.set("disclaimer", f.disclaimer.checked ? 1 : 0);

    return data;
  }
}

export default BasicForm;
